import { render, staticRenderFns } from "./referral_policy.vue?vue&type=template&id=8b928018&scoped=true"
import script from "./referral_policy.vue?vue&type=script&lang=js"
export * from "./referral_policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b928018",
  null
  
)

export default component.exports